import { createElement, memo, useCallback } from '@max/max';
import SlideModal from '@max/leez-slide-modal';
import { useSelector, useDispatch } from '@max/max-redux';
import View from '@hfe/max-view';
import CitySelection from './CitySelection';
import { useLocationInfo } from '../../hooks/useLocationInfo/index';
import { screenHeight, statusBarHeight } from '../../utils/utils';
import { useAllStates } from '../../hooks/useAllStates';
const isWeb = true;
import { Actions } from '../../store';
function CitySelectionModal(p) {
    useLocationInfo(p);
    const isShowCitySelection = useSelector(state => state.citySelection.isShowCitySelection);
    const dispatch = useDispatch();
    const dispatchEvent = useCallback((event) => {
        dispatch(event);
    }, [dispatch]);
    const emitCloseEventCallback = useCallback(() => {
        dispatchEvent({
            type: Actions.toggleCitySelection,
            data: false
        });
    }, []);
    // useEffect(() => {
    //   const { enableScroll, disableScroll } = p._pageAPI || {};
    //   if (disableScroll && enableScroll) {
    //     isWeb && isShowCitySelection ? disableScroll() : enableScroll();
    //   }
    // }, [isWeb, isShowCitySelection])
    const cityRecent = useSelector(state => state.citySelection.recentCity);
    const locationCity = useSelector(state => state.citySelection.locationCity);
    const cityDataSourceState = useSelector(state => state.citySelection.cityList);
    const allStates = useAllStates();
    let maxHeight = isWeb ? '60vh' : (screenHeight - statusBarHeight) * 0.6;
    return <View>
      <SlideModal visible={isShowCitySelection} showHeader={false} showCloseBtn={false} maskClosable addBottomSpace={false} modalMaxHeight={100} contentStyle={{
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
        padding: 0
    }} style={{
        borderRadius: 0,
        maxHeight: maxHeight,
        height: undefined
    }} onClosePress={emitCloseEventCallback}>
        <CitySelection dispatchEvent={dispatchEvent} cityRecent={cityRecent} allStates={allStates} locationCity={locationCity} _communication={p._communication} dispatchCity={p === null || p === void 0 ? void 0 : p.dispatchCity} cityDataSourceState={cityDataSourceState} _LXReport={p._LXReport}/>
      </SlideModal>
    </View>;
}
export default memo(CitySelectionModal);
